<template>
  <div>
    <cbs-collapse :trigger="getOptions() != null">
      <div>
        <v-select
          v-if="getOptions()"
          v-model="record[fieldKey()]"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="title"
          :options="getOptions()"
          :class="variant"
          :filter-by="filterBy"
          @input="onInputVSelect($event)"
        >
          <template
            slot="option"
            slot-scope="item"
          >
            {{ item.title }}
            <small class="text-muted"><i>({{ item.value }})</i></small>
          </template>
        </v-select>
        <div>
          <span>
            <feather-icon
              v-if="!noRefresh"
              icon="RotateCwIcon"
              class="cursor-pointer text-primary"
              @click="refreshRef()"
            />
            <a
              v-if="!noLink"
              style="margin-left:5px;"
              :href="'/cubus/object/' + field.refobjectid"
              target="_blank"
            ><feather-icon
              icon="ExternalLinkIcon"
              class="cursor-pointer text-primary"
            /></a>
          </span>
        </div>
      </div>
    </cbs-collapse>
    <cbs-data-reference
      v-if="!propRef"
      :ref="'ref_' + uuid"
      hide
      :entityid="refEntityId()"
      @load="onLoadRef"
    />
  </div>
</template>

<script>
import vSelect from 'vue-select'
import CbsDataReference from '@/cubus/components/reference/CbsDataReference.vue'
import CbsCollapse from '@/cubus/components/collapsible/CbsCollapse.vue'
import useCubus from '@/cubus/services/useCubus'

export default {
  name: 'CbsReferencePicker',
  components: {
    CbsCollapse,
    vSelect,
    CbsDataReference,
  },
  props: {
    field: {
      type: Object,
      default: null,
    },
    variant: {
      type: String,
      default: '',
    },
    record: {
      type: Object,
      default: null,
    },
    propRef: {
      type: Array,
      default: null,
    },
    noRefresh: {
      type: Boolean,
      default: false,
    },
    noLink: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'id', // 'id' or 'sid'
    },
  },
  emits: ['updateCell'],
  data() {
    return {
      ref: null,
      uuid: null,
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.uuid = useCubus.guid()
    },
    onLoadRef(ref) {
      this.ref = ref
    },
    filterBy(option, label, search) {
      const pattern = `^${search
        .replace(new RegExp(' ', 'gi'), '.*')
        .replace(new RegExp('\\.\\*\\.\\*', 'gi'), ' ')}.*`
      const re = new RegExp(pattern, 'gi')
      return re.test(label || '')
    },
    onInputVSelect(val) {
      if (!val) {
        this.record[this.fieldKey()] = { value: 0, title: '' }
      }
      this.$emit('updateCell', !val ? { value: 0, title: '' } : val)
    },
    refEntityId() {
      if (this.field.entitysid === 'parent') {
        return this.field.parententityid
      }
      return this.field.entityid
    },
    loadRef() {
      this.$refs[`ref_${this.uuid}`].loadRef()
    },
    refreshRef() {
      this.$refs[`ref_${this.uuid}`].loadRef()
    },
    getOptions() {
      return this.propRef || this.ref
    },
    fieldKey() {
      return this.mode === 'sid' ? this.field.entitysid : this.field.key
    },
  },
}
</script>

<style scoped>
</style>
